import styled from 'styled-components';

export const Fieldset = styled.fieldset`
  margin-bottom: 28px;
`;

export const Label = styled.label`
  font-weight: 700;
`;